<script setup>
  import { ref, onMounted, onErrorCaptured } from 'vue';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import ProForecast from '@/components/ProForecast.vue';
  import ErrorBlock from '@/components/ErrorBlock.vue';
  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import ModalSiteSettings from '@/components/ModalSiteSettings.vue';

  const { $PRO_FORECAST } = useContainerConfigurationGlobals();

  const proForecastStore = useProForecastStore();

  await proForecastStore.getProForecast($PRO_FORECAST.pro_forecast_id);
  await proForecastStore.getForecasters();

  const loadFooterAd = ref(false);
  const error = ref(null);

  onMounted(() => {
    loadFooterAd.value = true;
  });

  onErrorCaptured((e) => {
    console.warn(e);

    error.value = { 
      title: `There was a problem loading the Pro Forecast (${$PRO_FORECAST.pro_forecast_id})`,
      message: `Please try again later.`,
      errorText: e.message
    }

    console.warn('There was an error retrieving the Pro Forecast.', e);

    return false;
  })  
</script>

<template>
  <ErrorBlock v-if="error" :error="error" />
  <ProForecast ref="pro-forecast-container" v-else />
  <Suspense>
    <ModalSiteSettings />
  </Suspense>  
</template>